/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { RegistrySearchItem } from './RegistrySearchItem'
import {
  RegistrySearchItemFromJSON,
  RegistrySearchItemFromJSONTyped,
  RegistrySearchItemToJSON,
} from './RegistrySearchItem'

/**
 *
 * @export
 * @interface GetOtherRegistries200ResponseData
 */
export interface GetOtherRegistries200ResponseData {
  /**
   * Тип связи
   * @type {string}
   * @memberof GetOtherRegistries200ResponseData
   */
  searchBy: string
  /**
   * Заявки (зТЗ)
   * @type {Array<RegistrySearchItem>}
   * @memberof GetOtherRegistries200ResponseData
   */
  applications: Array<RegistrySearchItem>
  /**
   * Свидетельства (ТЗ), отсортированные по близости даты истечения действия
   * @type {Array<RegistrySearchItem>}
   * @memberof GetOtherRegistries200ResponseData
   */
  ipo: Array<RegistrySearchItem>
  /**
   * Количество свидетельств, не добавленных в пользовательские регистры
   * @type {number}
   * @memberof GetOtherRegistries200ResponseData
   */
  notAppendedIpo: number
}

/**
 * Check if a given object implements the GetOtherRegistries200ResponseData interface.
 */
export function instanceOfGetOtherRegistries200ResponseData(
  value: object
): value is GetOtherRegistries200ResponseData {
  if (!('searchBy' in value) || value['searchBy'] === undefined) return false
  if (!('applications' in value) || value['applications'] === undefined)
    return false
  if (!('ipo' in value) || value['ipo'] === undefined) return false
  if (!('notAppendedIpo' in value) || value['notAppendedIpo'] === undefined)
    return false
  return true
}

export function GetOtherRegistries200ResponseDataFromJSON(
  json: any
): GetOtherRegistries200ResponseData {
  return GetOtherRegistries200ResponseDataFromJSONTyped(json, false)
}

export function GetOtherRegistries200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOtherRegistries200ResponseData {
  if (json == null) {
    return json
  }
  return {
    searchBy: json['searchBy'],
    applications: (json['applications'] as Array<any>).map(
      RegistrySearchItemFromJSON
    ),
    ipo: (json['ipo'] as Array<any>).map(RegistrySearchItemFromJSON),
    notAppendedIpo: json['notAppendedIpo'],
  }
}

export function GetOtherRegistries200ResponseDataToJSON(
  value?: GetOtherRegistries200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    searchBy: value['searchBy'],
    applications: (value['applications'] as Array<any>).map(
      RegistrySearchItemToJSON
    ),
    ipo: (value['ipo'] as Array<any>).map(RegistrySearchItemToJSON),
    notAppendedIpo: value['notAppendedIpo'],
  }
}
